import Checkbox, { CheckboxProps as CheckboxPropsInternal } from "./Checkbox";

export type CheckboxProps = CheckboxPropsInternal;
export default Checkbox;
